"use client";

// CopyBlock — a block of text you are meant to take with you, with the taking
// built in.
//
// Every command and every link we print for a reader exists to be pasted
// somewhere else: `claude mcp add …` in a guide, the paste line on a skill, a
// snippet inside a skill's body. Printing it and leaving the reader to select
// it by hand is asking them to do the one thing a page can do for them, and
// selecting a wrapped command with a mouse is genuinely fiddly. So the block
// carries its own control: one press, and it is on the clipboard.
//
// It is not a box in the sense law_no_boxes forbids: the faint fill is the code
// block the house already had, with no line round it. The control is THE copy
// disc (the link bar's), come up in the corner on hover or focus (2026-10-25:
// the thin border and the worded pill read as boxes on boxes).
//
// Used by both markdown renderers (the docs/company one and the skill one), so
// a snippet behaves identically wherever it is read.

import CopyDisc from "./CopyDisc";

export default function CopyBlock({
  text,
  lang,
  className,
  children,
  raw = false,
}: {
  /** exactly what lands on the clipboard — the source, never the rendered html. */
  text: string;
  lang?: string;
  className?: string;
  /** the rendered block. Omitted, the text is printed as it stands. */
  children?: React.ReactNode;
  /** the caller brings its own block (its own <pre>, its own styling) and this
   *  only adds the control over it. */
  raw?: boolean;
}) {
  return (
    <div className={`copy-block${className ? ` ${className}` : ""}`} data-lang={lang || undefined}>
      {raw ? children : <pre className="sk-pre">{children ?? <code>{text}</code>}</pre>}
      {/* THE copy disc, come up on hover or focus (always there where nothing hovers) */}
      <CopyDisc text={text} className="copy-block__take" />
    </div>
  );
}
